import React, { useContext, useState, useEffect, useCallback } from 'react';
import "../../Styles/RecommendedExams.css";
import { useNavigate } from 'react-router-dom';
import { Packs } from '../Context/PacksContext';
import { MedicalContext } from '../Context/MedicalContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpLong, faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import packslist from "../../../JSONS/updatedPacks.json"
import examslist from "../../../JSONS/updatedExams.json"
import MakeItEasy from "../PacksPages/MakeItEasy"

function RecommendedExamsRoute() {

  const Navigate = useNavigate();

  const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
  const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
  const GenderNum = decodedToken ? parseInt(decodedToken.gender) : null;
  const GenderCat = GenderNum === 1 ? "M" : "F"

  const [VisualizePack,SetVisualizePack] = useState("")

  const {
    PreviewRelatedExams, SetRelatedExams
  } = useContext(MedicalContext);

  const {
    AllPacks, SetAdded, SetPurchased
  } = useContext(Packs);

  useEffect(() => {
    if(localStorage.getItem("PreviewRelatedExams") === null | localStorage.getItem("PreviewRelatedExams").length === 2) {
      Navigate("/recomendador-de-examenes")
    }
  })

  window.onscroll = function() {
    if(document.URL.includes("recomendacion")) {
      let tmp = document.getElementById("ToTheTop")
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        tmp.className = tmp.className.replace(" ScrollBackToTopHidden", "");
      } else {
        if(!tmp.className.includes("ScrollBackToTopHidden")) tmp.className += " ScrollBackToTopHidden"
      }
    }
  }

  const others = ["Imagenología", "Procedimientos"]

  const [ChosenExams, setChosenExams] = useState([]);
  const [OneTime, setOneTime] = useState(true);
  const [Checkout, setCheckout] = useState(false);
  const [PackPage,setPackPage] = useState(1)
  const [PacksShown,setPacksShown] = useState(window.innerWidth <= 620 ? 1 : window.innerWidth <= 920 ? 2 : 3)
  const [ChosenToSee, setChosenToSee] = useState(false);

  useEffect(() => {
    if(ChosenToSee) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      Navigate("/packs-de-examenes/detalles-de-pack?pack=".concat(VisualizePack))
    }
  });

  function ChangePack(pack) {
      SetVisualizePack(pack); 
      setChosenToSee(true);
  };

  const PreSelect = useCallback(() => {
    let Selected = PreviewRelatedExams
    let loadedExams = PreviewRelatedExams.filter(a => examslist[a].emission !== "")
    for(let i=0;i<loadedExams.length;i++) {
        if(Selected.includes(loadedExams[i])) {
        let tmp = document.getElementById(loadedExams[i])
        tmp.checked = true
        }
    }
    setChosenExams(Selected.filter(a => loadedExams.includes(a)))
  },[PreviewRelatedExams])

  useEffect(() => {
      if(OneTime && document.getElementById("ManageAll")) {
        PreSelect()
        setOneTime(false)
      }
      if(Checkout) {
        Navigate("/orden-medica")
      }
  },[OneTime,Checkout,PreSelect,Navigate]);

  function handleChosen(id) {
    let tmp = document.getElementById(id)
    let listtmp = ChosenExams
    if(id === 'ChooseAll') {
        if (tmp.checked) {
          for(let i=0; i<PreviewRelatedExams.length; i++) {
            let tmp2 = document.getElementById(PreviewRelatedExams[i])
            if(tmp2) {
              tmp2.checked = true
              listtmp.push(PreviewRelatedExams[i])
            }
          }
        } else {
            listtmp = []
            for(let i=0; i<PreviewRelatedExams.length; i++) {
                let tmp2 = document.getElementById(PreviewRelatedExams[i])
                if(tmp2) tmp2.checked = false
            }
        }
    }
    else {
      if (tmp.checked) {
        listtmp.push(id)
      } else {
        let index = listtmp.indexOf(id);
        if (index > -1) { 
          listtmp.splice(index, 1); 
        }
      }
    }
    //console.log([...new Set(listtmp)])
    setChosenExams([...new Set(listtmp)])
  }

  function ModifyPackCheckout() {
    SetRelatedExams([...ChosenExams])
    setCheckout(true)
  }

  function toggleAdditional(id) {
    let tmp = document.getElementById(id)
    if(tmp.className.includes("InformationCollapsed")) {
      tmp.className = tmp.className.replace(" InformationCollapsed", "");
    } else {
      tmp.className += " InformationCollapsed"
    }
  }

  function toggleDescription(id,type) {
    let tmp = document.getElementById(id.concat("More"))
    let tmp2 = document.getElementById(id.concat("Less"))
    if(type === "More") {
        tmp.className += " PacksSelectPackBoxWhiteBoxDescriptionHidden"
        tmp2.className = tmp2.className.replace(" PacksSelectPackBoxWhiteBoxDescriptionHidden", "");
    } else {
        tmp.className = tmp.className.replace(" PacksSelectPackBoxWhiteBoxDescriptionHidden", "");
        tmp2.className += " PacksSelectPackBoxWhiteBoxDescriptionHidden"
    }
  }
  
    return (
      <>
      {PreviewRelatedExams.length === 0 ?
      null 
    :
    <>
    <div className="PacksSelectOuterDiv">
      <div className="UserProfileInnerDiv">
        <div className='UserProfileWhiteBox PacksSelectWhiteBlock' id="ManageAll" style={{color:"#330066", marginBlockEnd:"20px"}}>
          <h5 className="UserProfilePageUpTitle">Órdenes Médicas</h5>
          <div className='RecommendedExamsFirstBlock'>
              <img className='RecommendedExamsFirstBlockImage' alt="" src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
              <div className='PacksSelectFirstBlockTexts' style={{maxWidth:"580px"}}>
                  <h2 className="RecommendedExamsFirstBlockTitle">Recomendación de exámenes personalizados para ti</h2>
                  <div className="PacksSelectFirstBlockSubtitle">Órdenes de exámenes, procedimientos y derivaciones.</div>
              </div>
          </div>
     <div className="RecommendedExamsAll" id="ManageAll">
      <div className="RecommendedExamsLeftSide">
        <div className='RecommendedExamsPackPriceFlex'>
          <div className='PackDetailsPackPrice' id="PriceDiv">$990</div>
          {ChosenExams.length === 0 ?
          <div className='LandingSlider2RightSideButtonFlex' style={{maxWidth:"100%", cursor:"default"}}>
            <div className='LandingSlider2RightSideButtonLeft'>
            Generar Orden
            </div>
            <div className="LandingSlider2RightSideButtonRight">
              <img alt="" className="LandingSlider2RightSideButtonRightImage" src="https://static.yomecontrolo.cl/public/icons/WhiteMedicalDataIcon.svg"/>
            </div>
          </div>
          : 
          <div className='LandingSlider2RightSideButtonFlex' style={{maxWidth:"100%"}} onClick={() => {SetAdded(false); SetPurchased(false); ModifyPackCheckout();}}>
            <div className='LandingSlider2RightSideButtonLeft'>
            Generar Orden
            </div>
            <div className="LandingSlider2RightSideButtonRight">
              <img alt="" className="LandingSlider2RightSideButtonRightImage" src="https://static.yomecontrolo.cl/public/icons/WhiteMedicalDataIcon.svg"/>
            </div>
          </div>
}
        </div>
        <div className="RecommendedExamsPackBoxImage" style={{backgroundImage:"linear-gradient(0deg, rgba(207,249,255,1) 0%, rgba(255,255,255,0) 100%),url('https://static.yomecontrolo.cl/public/img/packs/PF40YMC036.png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
        <div className="RecommendedExamsPackTextContainter">
          <div className="RecommendedExamsPackDescription">Muy bien {decodedToken ? decodedToken.name : null},<br/>
según tus antecedentes, hemos creado un pack con exámenes para cuidar de tu salud de manera preventiva, 
también hemos agregado exámenes para abordar puntos de riesgo en tu perfil especifico de paciente.</div>
        </div>
      </div>
      <div className="RecommendedExamsRightSide">
          <div className="RecommendedExamsChoiceTitleFlex">
            <h5 className="RecommendedExamsChoiceTitleLeft">Exámenes seleccionados para tí</h5>
            <img className="PackDetailsChoiceIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/SkyBlueMedicalDataIcon.svg" />
          </div>
          <div className="RecommendedExamsChoiceTitleDivider"></div>
          <>
          {PreviewRelatedExams.map(a => examslist[a].emission).includes('Laboratorio') ?
          <>
            <div className="PackDetailsChoiceLabelFlex">
              <h5 className="PackDetailsChoiceLabel">Laboratorio</h5>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/PurpleExamLaboratoryIcon.svg" />
            </div>
            <div className="RecommendedExamsChoiceExams">
            <>
            {PreviewRelatedExams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Laboratorio" ?
              <div className="RecommendedExamsChoiceExamsFlexedOuter">
                <div className="RecommendedExamsChoiceExamsFlexed">
                  <input type="checkbox" name="selectExam" className="RecommendedExamsChoiceExamSelect" id={key} onClick={() => handleChosen(key)}/>
                  <div className="RecommendedExamsChoiceExamName">{examslist[key].name}</div>
                  {examslist[key].additional === "" ?
                  null :
                    <div className="RecommendedExamsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                  }
                </div>
                <div className="PackDetailsAllExamsSingleExamBlockDescr">{examslist[key].description}</div>
                <div className="RecommendedExamsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
                </div>
                :
                null}
              </div>
            ))}
            </>
            </div> 
          </>
          : null}
          {others.some((el) => PreviewRelatedExams.map(a => examslist[a].emission).includes(el)) ?
          <>
            <div className="PackDetailsChoiceLabelFlex">
              <h5 className="PackDetailsChoiceLabel">Imagenología y Procedimientos</h5>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/PurpleExamImagenologyIcon.svg" />
            </div>
            <div className="RecommendedExamsChoiceExams">
            {PreviewRelatedExams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Imagenología" | examslist[key].emission === "Procedimientos" ?
              <div className="RecommendedExamsChoiceExamsFlexedOuter">
                <div className="RecommendedExamsChoiceExamsFlexed">
                  <input type="checkbox" name="selectExam" className="RecommendedExamsChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                  <span className="RecommendedExamsChoiceExamName">{examslist[key].name}</span>
                  {examslist[key].additional === "" ?
                  null :
                    <div className="RecommendedExamsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                  }
                </div>
                <div className="PackDetailsAllExamsSingleExamBlockDescr">{examslist[key].description}</div>
                <div className="RecommendedExamsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </div>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          {PreviewRelatedExams.map(a => examslist[a].emission).includes('Derivaciones') ?
          <>
            <div className="PackDetailsChoiceLabelFlex">
              <h5 className="PackDetailsChoiceLabel">Derivaciones</h5>
              <img className="OrderCheckoutInnerBoxUpperRowTinyIcon" alt='' src="https://static.yomecontrolo.cl/public/icons/PurpleExamDerivationsIcon.svg" />
            </div>
            <div className="RecommendedExamsChoiceExams">
            {PreviewRelatedExams.map((key) => (
              <div key={key}>
              {examslist[key].emission === "Derivaciones" ?
              <div className="RecommendedExamsChoiceExamsFlexedOuter">
                <div className="RecommendedExamsChoiceExamsFlexed">
                  <input type="checkbox" name="selectExam" className="RecommendedExamsChoiceExamSelect" id={key} onClick={() => handleChosen(key)} />
                  <span className="RecommendedExamsChoiceExamName">{examslist[key].name}</span>
                  {examslist[key].additional === "" ?
                  null :
                    <div className="RecommendedExamsChoiceExamInfo" onClick={() => toggleAdditional("Added".concat(key))}>?</div>
                  }
                </div>
                <div className="PackDetailsAllExamsSingleExamBlockDescr">{examslist[key].description}</div>
                <div className="RecommendedExamsChoiceSpecifics InformationCollapsed" id={"Added".concat(key)}>{examslist[key].additional}</div>
              </div>
              :
              null}
              </div>
            ))}
            </div>
          </>
          : null}
          </> 
        </div>
     </div>

        {AllPacks.length !== 0 ?
        <div className="RecommendedExamsPacksDiv">
            <div className="RecommendedExamsPacksTitle">Complementa tu chequeo con alguna de estas sugerencias</div>
            <div className="RecommendedExamsPacksPackBoxesFullLineFlex">
              {PackPage === 1 ?
              null :
              <div className='RecommendedExamsPacksLeftArrowDiv' onClick={() => setPackPage(PackPage-1)}>
                <FontAwesomeIcon 
                    icon={faArrowRightLong} 
                    className='RecommendedExamsPacksLeftArrow text-end fa-rotate-180'
                />
              </div>
              }

              <div className="RecommendedExamsPacksPackBoxesFlex">
                  {AllPacks.filter(a => packslist[a].gender === "Mixed" || packslist[a].gender === GenderCat).slice(PacksShown*(PackPage-1),PacksShown*PackPage).map((pack) => (
                  <div className="RecommendedExamsPacksPackBox" key={pack}>
                    <div className='PacksSelectPackBoxBackImage' style={{backgroundImage:"linear-gradient(0deg, rgba(207,249,255,1) 0%, rgba(255,255,255,0) 50%),url('https://static.yomecontrolo.cl/public/img/packs/"+ pack +".png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
                      <div className="PacksSelectPackBoxWhiteBox">
                          <div className="RecommendedExamsPacksPackBoxWhiteBoxTitle">{packslist[pack].name}</div>
                          <div className="PacksSelectPackBoxWhiteBoxDescription" id={pack.concat("More")}>{packslist[pack].description.split(' ').slice(0,12).join(' ')} &nbsp;
                              <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"More")}>Leer más...</span>
                          </div>
                          <div className="PacksSelectPackBoxWhiteBoxDescription PacksSelectPackBoxWhiteBoxDescriptionHidden" id={pack.concat("Less")}>{packslist[pack].description} &nbsp;
                              <span className='PacksSelectPackBoxWhiteBoxTextOption' onClick={() => toggleDescription(pack,"Less")}>Leer menos...</span>
                          </div>
                          <div className="RecommendedExamsPacksPackBoxWhiteBoxFlex">
                              <div className="PackDetailsPacksPackBoxWhiteBoxPrice">${packslist[pack].price}</div>
                          </div>
                          <div className="PacksSelectPackBoxWhiteBoxMoreInfoButton" onClick={() => { document.body.scrollTop = 0; document.documentElement.scrollTop = 0; ChangePack(pack);}}>Más Información</div>
                      </div>
                  </div>
                  ))}
              </div>

              {PackPage === Math.ceil(AllPacks.filter(a => packslist[a].gender === "Mixed" || packslist[a].gender === GenderCat).length / PacksShown) ?
              null :
              <div className='RecommendedExamsPacksRightArrowDiv' onClick={() => setPackPage(PackPage+1)}>
                <FontAwesomeIcon 
                    icon={faArrowRightLong} 
                    className='RecommendedExamsPacksRightArrow text-end'
                />
              </div>
              }

            </div>
        </div>
        : null}
      </div>
        <MakeItEasy/>

        <div className='ScrollBackToTopOuter ScrollBackToTopHidden' id="ToTheTop">
            <div className='ScrollBackToTop' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
            <FontAwesomeIcon 
                icon={faUpLong} 
                className='ScrollBackToTopUpArrow'
            />
            </div>
        </div>
        </div>
        </div>
      </>
}
    </>
  );
}

export default RecommendedExamsRoute;